// @core/api/endpoints/payment/capture_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CapturePaymentRequest,
  CapturePaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Capture authorized payment
 * Captures a previously authorized payment. Can capture full or partial amount.
 */
export async function CapturePayment(
  id: string,
  data: CapturePaymentRequest,
  options?: RequestOptions
): Promise<CapturePaymentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payments/:id/capture`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<CapturePaymentResponse>(requestPath, data, requestOptions);
}
